var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "trinity-rings-spinner", style: _vm.spinnerStyle },
    [
      _c("div", { staticClass: "circle circle1", style: _vm.ring1Style }),
      _vm._v(" "),
      _c("div", { staticClass: "circle circle2", style: _vm.ring2Style }),
      _vm._v(" "),
      _c("div", { staticClass: "circle circle3", style: _vm.ring3Style })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }